import { render, staticRenderFns } from "./MenuMobileItem.vue?vue&type=template&id=3d7874c2&"
import script from "./MenuMobileItem.vue?vue&type=script&lang=js&"
export * from "./MenuMobileItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports